import { middlewareContext } from '@/router'

export default function redirectRestore ({ next, store, nextMiddleware }: middlewareContext): void | Promise<unknown> {
  if (!store.getters['profile/getDeletionRequested']) {
    return next({ name: 'Profile' })
  }
  return nextMiddleware()
}
